import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { WireGuardTunnel } from "./SiteAboutPageUtils/siteAboutInterfaces";

export const WireGuardTunnelSelect = ({
  tunnels,
  selectedTunnelId,
  onSelectTunnelId,
}: {
  tunnels: WireGuardTunnel[];
  selectedTunnelId: number | null;
  onSelectTunnelId: (id: number) => void;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const selected =
    tunnels.find((t) => t.id === selectedTunnelId) ?? tunnels[0] ?? null;
  const label = selected?.name ?? "—";

  if (tunnels.length <= 1) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="text-[14px] font-mulish pl-[15px] pt-[10px]">
       AVAILABLE WIREGUARD TUNNELS:
        <Button
          id="wireguard-tunnel-filter-button"
          aria-controls={open ? "wireguard-tunnel-filter-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{ paddingBottom: "8px", fontSize: "14px", fontFamily: "Mulish" }}
        >
          {label}
        </Button>
        <Menu
          id="wireguard-tunnel-filter-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "wireguard-tunnel-filter-button",
          }}
        >
          {tunnels.map((t) => (
            <MenuItem
              key={t.id}
              onClick={() => {
                onSelectTunnelId(t.id);
                setAnchorEl(null);
              }}
              sx={{ fontFamily: "Mulish" }}
            >
              {t.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </div>
  );
};
